import Model from '@/lib/data/Model';

class AccessRoleFunction extends Model {
    static idProperty = 'id';

    fields = ['id', 'module_name', 'function_name', 'valid_access_code', 'access_code'];

    constructor(data) {
        super(data);
        this.init();
    }

    api = [];
}

export default AccessRoleFunction;
